export const Banniere = () =>{
    return(
        <>
             <div className="main-banner wow fadeIn" id="accueil" data-wow-duration="1s" data-wow-delay="0.5s">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-7 align-self-center">
              <div className="left-content header-text wow fadeInLeft" data-wow-duration="1s" data-wow-delay="1s">
                <h2 style={{color: "#FE3F40", fontSize: "3em"}} className="mb-5">Bienvenue dans TaxePaye</h2>
                <h4 style={{ fontWeight:"normal"}}>Une plateforme de paiement en ligne des impôts et pénalités au Congo Brazzaville. Simplifiez vos démarches fiscales en effectuant vos paiements en ligne en quelques clics. Notre service sécurisé et convivial est conçu pour faciliter vos obligations fiscales.</h4>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="right-image wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.5s">
                <img src="assets/images/taxeForm.png" alt="team meeting" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}